import { Field, FastField, FieldProps } from "formik";
import get from "lodash.get";
import React from "react";
import { TextInput } from "../../../../../ui/widgets/text-input";
import { TextInputProps } from "../../../../../ui/widgets/text-input/types";

interface TextInputWrapperPropsType extends TextInputProps {
  field: FieldProps["field"];
}

const TextInputWrapper = ({ field, ...props }: TextInputWrapperPropsType) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange({
      target: {
        value: event.target.value,
        id: field.name,
      },
    });
    if (props.onChange) {
      props.onChange(event);
    }
  };

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    field.onBlur({
      target: {
        value: event.target.value,
        id: field.name,
      },
    });
    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  const error = get(props, `form.errors.${field.name}`);
  const touched = get(props, `form.touched.${field.name}`);

  return (
    <TextInput
      id={field.name}
      {...field}
      {...props}
      error={!!(error && touched)}
      onChange={onChange}
      onBlur={onBlur}
      helperText={touched && error}
      shrink={props.shrink ? props.shrink : Boolean(field.value)}
    />
  );
};

export default function TextInputField(
  props: TextInputProps,
): React.JSX.Element {
  return props.forceReRender ? (
    <Field component={TextInputWrapper} {...props} />
  ) : (
    <FastField component={TextInputWrapper} {...props} />
  );
}
